<!-- Inicio requerimiento PLUS-0097-H5 Samunoz -->
<div class="psm">
    <header class="psm__header">
        <span class="psm__eyebrow">Configuración de seguridad de tu cuenta</span>
    </header>

    <div class="psm__body">
        @if (modo === 'crearContrasena') {
        <div class="psm__banner">Contraseña creada. Último paso: registra tus preguntas de seguridad.</div>
        }

        @if (esEdicion) {
        <h1 class="psm__title">Tus preguntas de seguridad</h1>
        <p class="psm__subtitle">
            Puedes modificar la pregunta o la respuesta que desees actualizar.
            Las demás se mantendrán como están. Para confirmar los cambios, ingresa tu contraseña de acceso.
        </p>
        } @else {
        <h1 class="psm__title">Registra tus preguntas de seguridad</h1>
        <p class="psm__subtitle">
            Para tu seguridad, selecciona y responde
            <strong>{{ cantidadRequerida }} preguntas</strong> que puedas recordar.
        </p>
        }

        @if (cargandoCatalogo) {
        <p class="psm__hint">Cargando preguntas…</p>
        }

        @if (errorCatalogo) {
        <p class="psm__error" role="alert">{{ errorCatalogo }}</p>
        }

        @if (!cargandoCatalogo && !errorCatalogo && anadidas.length < cantidadRequerida) {
        <div class="psm__builder" [class.psm__builder--invalid]="errorSeleccion || errorRespuesta">
            <label class="psm__label" for="sel-pregunta">
                Selecciona la pregunta {{ anadidas.length + 1 }} de {{ cantidadRequerida }}
            </label>
            <select
                id="sel-pregunta"
                class="psm__select"
                [(ngModel)]="codigoSeleccionado"
                [attr.aria-invalid]="errorSeleccion">
                <option value="">Elige una pregunta…</option>
                @for (p of disponibles; track p.codigo) {
                <option [value]="p.codigo">{{ p.pregunta }}</option>
                }
            </select>
            @if (errorSeleccion) {
            <span class="psm__field-error">Selecciona una pregunta.</span>
            }

            <label class="psm__label" for="respuesta-pregunta">Tu respuesta</label>
            <input
                id="respuesta-pregunta"
                class="psm__input"
                type="text"
                maxlength="20"
                [(ngModel)]="respuestaActual"
                placeholder="Escribe tu respuesta"
                [attr.aria-invalid]="errorRespuesta" />
            @if (errorRespuesta) {
            <span class="psm__field-error">La respuesta debe tener entre 2 y 20 caracteres (sin - ' =).</span>
            }

            <button type="button" class="psm__btn psm__btn--secondary" (click)="anadir()">
                {{ anadidas.length === cantidadRequerida - 1 ? 'Añadir última pregunta' : (anadidas.length === 0 ? 'Añadir pregunta' : 'Añadir otra pregunta') }}
            </button>
        </div>
        }

        @if (!cargandoCatalogo && !errorCatalogo && anadidas.length >= cantidadRequerida && !esEdicion) {
        <p class="psm__hint">
            Ya añadiste tus {{ cantidadRequerida }} preguntas. Puedes quitar alguna si quieres cambiarla.
        </p>
        }

        <section class="psm__added" aria-labelledby="t-added">
            <h2 id="t-added" class="psm__added-title">
                @if (esEdicion) {
                Preguntas registradas ({{ anadidas.length }} de {{ cantidadRequerida }})
                } @else {
                Preguntas añadidas ({{ anadidas.length }} de {{ cantidadRequerida }})
                }
            </h2>
            @if (anadidas.length === 0) {
            <span class="psm__hint">Aún no has añadido preguntas.</span>
            } @else {
            <ul class="psm__list">
                @for (item of anadidas; track item.codigo; let i = $index) {
                <li class="psm__list-item" [class.psm__list-item--edit]="esEdicion">
                    <div class="psm__list-main">
                        <span class="psm__list-text">{{ i + 1 }}. {{ item.pregunta }}</span>
                        @if (esEdicion) {
                        <label class="psm__label psm__label--compact" [attr.for]="'resp-' + item.codigo">
                            Respuesta
                        </label>
                        <input
                            [id]="'resp-' + item.codigo"
                            class="psm__input"
                            type="text"
                            maxlength="20"
                            [(ngModel)]="item.respuesta"
                            name="resp-{{ item.codigo }}"
                            placeholder="*****"
                            [attr.aria-invalid]="intentoFinalizar && !esRespuestaEditableOk(item)" />
                        }
                    </div>
                    <button
                        type="button"
                        class="psm__remove"
                        [attr.aria-label]="'Quitar pregunta: ' + item.pregunta"
                        (click)="quitar(item.codigo)">
                        Quitar
                    </button>
                </li>
                }
            </ul>
            }
            <div class="psm__rest">
                <span>Preguntas restantes</span>
                <strong [class.psm__rest--ok]="restantes === 0">{{ restantes }}</strong>
            </div>
        </section>

        @if (requiereContrasena && !cargandoCatalogo && !errorCatalogo) {
        <div class="psm__password" [class.psm__password--invalid]="errorContrasena">
            <label class="psm__label" for="psm-contrasena">
                Confirma tu contraseña para guardar
            </label>
            <div class="psm__password-row">
                <input
                    id="psm-contrasena"
                    class="psm__input"
                    [type]="ocultarContrasena ? 'password' : 'text'"
                    [(ngModel)]="contrasenaActual"
                    name="contrasenaActual"
                    autocomplete="current-password"
                    placeholder="Contraseña de acceso"
                    [attr.aria-invalid]="errorContrasena" />
                <button
                    type="button"
                    class="psm__password-toggle"
                    (click)="toggleVisibilidadContrasena()"
                    [attr.aria-label]="ocultarContrasena ? 'Mostrar contraseña' : 'Ocultar contraseña'"
                    [attr.aria-pressed]="!ocultarContrasena">
                    @if (ocultarContrasena) {
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 12s4-7 10-7 10 7 10 7-4 7-10 7S2 12 2 12z"></path><circle cx="12" cy="12" r="3"></circle></svg>
                    } @else {
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 3l18 18"></path><path d="M10.6 6.1A10 10 0 0 1 12 6c6 0 10 6 10 6a17 17 0 0 1-3.2 3.8M6.6 6.6C3.8 8.4 2 12 2 12s4 6 10 6a9.7 9.7 0 0 0 5.4-1.6"></path><path d="M9.9 9.9a3 3 0 0 0 4.2 4.2"></path></svg>
                    }
                </button>
            </div>
            @if (errorContrasena) {
            <span class="psm__field-error">Ingresa tu contraseña para continuar.</span>
            }
        </div>
        }

        @if (intentoFinalizar && anadidas.length < cantidadRequerida) {
        <p class="psm__error" role="alert">Añade las {{ cantidadRequerida }} preguntas para completar.</p>
        }
        @if (errorRespuestasLista) {
        <p class="psm__error" role="alert">
            @if (esEdicion) {
            Si actualizas una respuesta, debe tener entre 2 y 20 caracteres (sin - ' =).
            Si eliges una pregunta nueva, también debes indicar su respuesta.
            } @else {
            Cada respuesta debe tener entre 2 y 20 caracteres (sin - ' =).
            }
        </p>
        }
    </div>

    <footer class="psm__footer">
        <button
            type="button"
            class="psm__btn psm__btn--primary"
            [disabled]="finalizando || cargandoCatalogo || !!errorCatalogo"
            [class.psm__btn--disabled]="!completo"
            (click)="completar()">
            @if (finalizando) {
            Guardando…
            } @else if (esEdicion) {
            Guardar cambios
            } @else {
            Completar registro de seguridad
            }
        </button>
    </footer>
</div>
<!-- Fin requerimiento PLUS-0097-H5 Samunoz -->
